"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alias = void 0;
const tslib_1 = require("tslib");
const PUSH_ALIAS = require("../alias");
class Alias {
    constructor(env) {
        /**
         * @description - fetches alias information
         * @param {AliasOptions} options - options related to alias
         * @returns Alias details
         */
        this.info = (options) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                return yield PUSH_ALIAS.getAliasInfo(Object.assign(Object.assign({}, options), { env: this.env }));
            }
            catch (error) {
                throw new Error(`Push SDK Error: API : alias::info : ${error}`);
            }
        });
        this.env = env;
    }
}
exports.Alias = Alias;
//# sourceMappingURL=alias.js.map